<p-dialog [(visible)]="displayDialog" header="Edit File Permissions" [dismissableMask]="false" [responsive]="true"
          [modal]="true" [style]="PrimeNgConfig.DialogStyle65" (onHide)="onClickCloseDialog();" [closable]="false"
          [contentStyle]="{'min-height':'400px'}">
  <div class="instruction-text">Select the roles that will have permission to access the files associated with this transaction. For each selected role provide
    the default permission setting for accessing the files.
  </div>
  <div>
    <div class="p-col-12" style="margin-bottom:10px;">
      <p-multiSelect [options]="roles"
                     [(ngModel)]="selectedRoles"
                     (onChange)="onChangeRole()"></p-multiSelect>
    </div>

    <app-data-table [columns]="actionTableColumns" [value]="filePermissions" sortField="role" [disableSearch]="true">
      <ng-template #actionTemplate let-row="row">
        <button *ngIf="user?.managingOrgId===DefaultOrg.OrgId"
                pButton class="icon-negative" icon="fa fa-trash" pTooltip="Delete" tooltipPosition="top"
                (click)="onClickDeletePermission(row)"></button>
      </ng-template>
    </app-data-table>
  </div>

  <div>
    <div *ngIf="roleConfigForSelectedTxn.length>0 && settingType===FilePermissionSettingType.DefaultPermission" class="p-col-12">
      <div class="instruction-text"> Extra role configuration for Transaction
      </div>
      <app-data-table *ngIf="roleConfigForSelectedTxn.length>0 && settingType===FilePermissionSettingType.DefaultPermission"
                      [columns]="roleConfigTableColumns" [value]="roleConfigForSelectedTxn">
      </app-data-table>

    </div>
  </div>
  <p-footer>
    <div style="text-align:right;padding-top:15px;">
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel"
              (click)="onClickCloseDialog()"></button>
      <button pButton type="button" class="button-action" icon="fa fa-check" label="Save"
              (click)="onClickSavePermissions()"></button>
    </div>
  </p-footer>
</p-dialog>
